﻿// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your JavaScript code.



//-----------------´Från Home.cshtml

export function initSite() {

    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({ 'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start' });
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true; g.src = 'https://tracking.webbanalys.msb.se/js/container_IWweAsmU.js'; s.parentNode.insertBefore(g, s);

    $('#update-button').on('click', function () {
        SetUpdate(1);
    });
    $('#notnow-button').on('click', function () {
        SetUpdate(0);
    });
    $('#hidemessage-button').on('click', function () {
        SetUpdate(2);
    });

    let sub = window.location.href.indexOf('/calc') > -1 ? '/calc' : '';
    function SetUpdate(typ) {
        document.body.classList.add('busy-cursor');
        let url = sub + "/Update/SetUpdateFlag?typ=" + typ;
        switch (typ) {
            case 0:
                document.getElementById("UpdateInfoContainerMain").classList.toggle("hide");
                break;
            case 1:
                {
                    document.getElementById("UpdateInfoContainerMain").classList.toggle("hide");
                    document.getElementById("UpdateInfoContainerResult").classList.toggle("hide");
                }
                break;
            case 2:
                document.getElementById("UpdateAppContainer").classList.toggle("hide");
                break;
        }

        $.post(url)
            .done(function (data) {
                if (typ == 1) {
                    $("#UpdateContainer").hide();
                }

                if (typ == 1) {
                    location.reload();
                }
                document.body.classList.remove('busy-cursor');
            });

    }

    //-----------------Slut Home.cshtml

    //-----------------Från DatabaseInfo/Index.cshtml

    $('.goback').on('click', function () {
        GoBack();
    });


    function GoBack() {
        window.history.back()
    }
            
    //-----------------Slut DatabaseInfo/Index.cshtml

    function menuToggle() {
        document.getElementById("mobileMainMenu").classList.toggle("hide");
    }

    $('#mainMenuToggleButton').on('click', function () {
        menuToggle();
    });
}